//////////////////////////////////////////
//                  KEY                 //
//                                      //
// First Letter: Color/Style indicator  //
// Second Letter:                       //
//   B = colors background              //
//   T = colors text                    //
//   D = decorator                      //
// Bright: Add an extra b to beginning  //
//                                      //
//                 NOTE                 //
// Not everything supports 4-bit colors //
// (bright colors are 4-bit)            //
//////////////////////////////////////////
export const ansiReset = '\u001b[0m';
export const aR = ansiReset;
// Black
export const bT = '\u001b[30m'; // Useful for bright backgrounds
export const bB = '\u001b[40m';
export const bbT = '\u001b[90m'; // Logs of minor importance
export const bbB = '\u001b[100m';
// Red
export const rT = '\u001b[31m'; // is disabled/major warnings/unexpected results
export const rB = '\u001b[41m'; // I use this when non-crashing errors occur
export const brT = '\u001b[91m';
export const brB = '\u001b[101m';
// Green
export const gT = '\u001b[32m'; // I use this for success/enabled messages
export const gB = '\u001b[42m';
export const bgT = '\u001b[92m';
export const bgB = '\u001b[102m';
// Yellow
export const yT = '\u001b[33m'; // I use this for minor warnings
export const yB = '\u001b[43m'; // I use this for notices
export const byT = '\u001b[93m';
export const byB = '\u001b[103m';
// Blue
export const buT = '\u001b[34m'; // I use this for parameters and arguments
export const buB = '\u001b[44m';
export const bbuT = '\u001b[94m'; //  I use bright blue for logs I plan to
export const bbuB = '\u001b[104m'; // delete so they're easier to spot
// Purple
export const pT = '\u001b[35m'; // I use this for component/file names
export const pB = '\u001b[45m';
export const bpT = '\u001b[95m'; // I use this for API calls
export const bpB = '\u001b[105m';
// Cyan
export const cT = '\u001b[36m'; // I use this for function names
export const cB = '\u001b[46m';
export const bcT = '\u001b[96m'; // I use this for Redux Slice logs
export const bcB = '\u001b[106m';
// White
export const wT = '\u001b[37m';
export const wB = '\u001b[47m'; // I use this for timers
export const bwT = '\u001b[97m';
export const bwB = '\u001b[107m';
// Text Decorators
export const bD = '\u001b[1m'; // Bold
export const lD = '\u001b[2m'; // font-weight: light
export const iD = '\u001b[3m'; // Italic
export const uD = '\u001b[4m'; // Underline
export const blinkD = '\u001b[5m'; // Causes the text to slowly blink
// UNIQUE
export const logLabel = `🏪${bD}${rB}${wT}next-gen-kiosk${ansiReset}: `;
export const tLog = `${bD}${gT}True${aR}`;
export const fLog = `${bD}${rT}False${aR}`;
